import PropTypes from 'prop-types';
import cx from 'classnames';
import Block from 'core/components/GridBlock';
import withTheme from 'core/hocs/withTheme';
import themePropTypes from 'core/utils/prop-types/theme';
import { resolveScopedStyles } from 'core/utils/styled-jsx';

import styles from './index.styl';

function SideColumn(props) {
  const {
    children,
    theme,
    className,
    ...otherProps
  } = props;

  const scoped = resolveScopedStyles(
    <scope>
      <style jsx>{`
        .sideColumn
          margin-left ${theme.layout.sideColumnIndent}
      `}</style>
    </scope>
  );

  return (
    <Block
      width='300px'
      mobile={0}
      className={cx(scoped.wrapClassNames('sideColumn'), className)}
      {...otherProps}
    >
      <div className={styles.column}>
        {children}
      </div>
      <scoped.styles />
    </Block>
  );
}

SideColumn.propTypes = {
  /** @ignore */
  theme: themePropTypes(`
    {
      layout: {
        sideColumnIndent,
      },
    }
  `),
  /** @ignore */
  className: PropTypes.string,
};

const SideColumnWithHOCs = withTheme(SideColumn);
SideColumnWithHOCs.displayName = 'SideColumn';

export { SideColumn as StorybookComponent };
export default SideColumnWithHOCs;
